<script lang="ts">
	import IKS from "./IKS.svelte";

	export let roadAddress = "";
	export let numbAddress = "";
	export let editmode = false;

</script>

<IKS name={'주소'} slotHasPadding cover={editmode}>
	<img src="/img/icons/placeAddress.png" alt="Address Icon" slot="image" />
	<div class="container">
		<p class="road">{roadAddress}</p>
		<p class="numb">{numbAddress}</p>
	</div>
</IKS>

<style lang="scss">
	@import "../../../variables.scss";

	img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	.container {
		display: flex;
		flex-direction: column;
		gap: 6.5px;
		.road {
			font-weight: 500;
			color: #46474b;
		}
		.numb {
			font-weight: 400;
			color: #6d6f76;
			font-size: 0.875rem;
		}
	}

	@include DesktopSize {
		.container {
			gap: 10px;
			.road {
				font-size: 1.25rem;
			}
			.numb {
				font-size: 1.125rem;
			}
		}
	}

</style>
